<template>
<!-- Add Registrar -->
  <div class="vx-row">
    <vx-card class="centered-page-container">
      <form class="add-partner-tabs" @submit.prevent="submit">
        <div class="vx-row flex-wrap px-5">
          <h2 class="partner-page-title"> Add Registrar - Tucows</h2>
        </div>

        <hr>

        <div class="indent-section add-reg-tabs">
          <div class="tab-text">
            <div class="vx-row mt-10">
              <div class="vx-col">
                <h5 class="tab-title">Registrar Details</h5>
              </div>
            </div>

            <div class="vx-row mt-6">
              <div class="vx-col w-1/4">
                <label class="vs-input--label inline-flex pb-2">Registrar Name *</label>
                <vs-input
                  class="w-full"
                  v-validate="{ required: !formDataRegistrar['legal_name'] }"
                  name="Registrar Name"
                  data-vv-validate-on="change"
                  mode="lazy"
                  v-model="formDataRegistrar['legal_name']" 
                  :danger="errors.has('Registrar Name')"
                  danger-text="Required field"/>
              </div>

              <div class="vx-col w-1/4">
                <label class="vs-input--label inline-flex pb-2">Registrar Short Name *</label>
                <vs-input
                  class="w-full"
                  v-validate="{ required: !formDataRegistrar['name'], max:50, regex: /^[a-zA-Z0-9]+(?:[ ]?[a-zA-Z0-9]+)*$/ }"
                  name="Registrar Short Name"
                  data-vv-validate-on="change"
                  mode="lazy"
                  :danger="errors.has('Registrar Short Name') || (formDataRegistrar['name'] ? formDataRegistrar['name'].length : 0) > 50"
                  :danger-text="errors.has('Registrar Short Name') ? (errors.items.find(x => x.field == 'Registrar Short Name').rule == 'required' ? 'Required field' : errors.items.find(x => x.field == 'Registrar Short Name').msg) : characterCount"
                  v-model="formDataRegistrar['name']" />
              </div>

              <div class="vx-col w-1/4">
                <label class="vs-input--label inline-flex pb-2">Account Manager</label>
                <v-select
                  name="Account Manager"
                  class="w-full"
                  v-model="formDataRegistrar['accountManager']"
                  :options="formAMs"
                  :closeOnSelect="true"
                  :clearable="false"></v-select>
              </div>

              <div class="vx-col w-1/4">
                <label class="vs-input--label inline-flex pb-2">Country</label>
                <v-select
                  name="Country"
                  class="w-full"
                  v-model="formDataRegistrar['country']"
                  :options="formGeo"
                  :closeOnSelect="true"
                  :clearable="false"></v-select>
              </div>
            </div>

            <div class="vx-row mt-4">
              <div class="vx-col w-1/4">
              <label class="vs-input--label inline-flex pb-2">Website</label>
                <vs-input
                  class="w-full"
                  name="Website"
                  v-model="formDataRegistrar['website']" 
                  v-validate="'url'"
                  data-vv-validate-on="change"
                  :danger="formDataRegistrar['website'] ? errors.has('Website') : false"
                  :danger-text="'Invalid URL'"/>
              </div>
            </div>

            <div class="vx-row mt-4">
              <div class="vx-col w-1/4">
                <label class="vs-input--label inline-flex pb-2">Tucows Name *</label>
                <v-select
                  name="Tucows Names"
                  class="w-full"
                  :class="errors.has('Tucows Names') ? 'select-required-error' : ''"
                  v-model="formDataRegistrar['tucows_onboarding_registrar']"
                  :options="formTucowsOnboardingRegistrars"
                  :closeOnSelect="true"
                  :clearable="false"
                  v-validate="!formDataRegistrar['tucows_onboarding_registrar'] ? 'required' : ''"
                  mode="eager"
                  data-vv-validate-on="change"
                  :required="!formDataRegistrar['tucows_onboarding_registrar']"></v-select>

                  <span v-if="errors.has('Tucows Names')" class="select-required-error--span span-text-validation"> Required field </span>
              </div>

              <div class="vx-col w-1/4">
                <label class="vs-input--label inline-flex pb-2">IANA ID</label>
                <vs-input
                  class="w-full"
                  type="number"
                  name="IANA ID"
                  :value="formDataRegistrar['tucows_onboarding_registrar'] ? formDataRegistrar['tucows_onboarding_registrar']['iana_id'] : null"
                  readonly />
              </div>
            </div>

            <hr class="my-12">

            <div class="vx-row">
              <vs-button class="mt-2 ml-auto" type="filled" button="submit" icon-pack="feather" icon="icon-save">Save</vs-button>
            </div>
          </div>
        </div>
      </form>
    </vx-card>

    <!-- Error Prompt -->
    <custom-prompt :activePrompt.sync="customPrompt['activePrompt']" :title="customPrompt['title']" :buttonText="customPrompt['buttonText']" :type="customPrompt['type']" :color="customPrompt['color']" :classList="customPrompt['classList']">
      <div class="con-content" slot="content">
        <p>Please solve the following errors: <br><ul class="error-body">{{ customPromptError }}</ul></p>
      </div>
    </custom-prompt>
    <!--  -->
  </div>
<!--  -->
</template>

<script>
import vSelect from "vue-select";
import CustomPrompt from "@/components/CustomPrompt.vue";

export default {
  name: 'AddTucowsRegistrar',
  components: {
    "v-select": vSelect,
    CustomPrompt
  },
  data() {
    return {
      formDataRegistrar: {
        legal_name: null,
        name: null,
        accountManager: {
          label: 'NA',
          value: null
        },
        country: {
          label: 'NA',
          value: null
        },
        website: null,
        tucows_onboarding_registrar: null,
        iana_id: null
      },
      customPrompt: {
        activePrompt: false,
        title: null,
        buttonText: null,
        type: null,
        color: null,
        classList: null,
        accept: null
      },
      customPromptError: null
    }
  },
  created() {
    this.$store.dispatch('setTucowsOnboardingRegistrars');
  },
  computed: {
    user_role() {
      return JSON.parse(localStorage.getItem("userDetails")).role;
    },
    user_id() {
      return JSON.parse(localStorage.getItem("userDetails")).id;
    },
    formGeo() {
      return this.$store.getters.formGeo;
    },
    formAMs() {
      return this.$store.getters.formAMs;
    },
    formTucowsOnboardingRegistrars() {
      return this.$store.getters.formTucowsOnboardingRegistrars;
    },
    characterCount() {
      return 'Character Count: ' + (this.formDataRegistrar['name'] ? this.formDataRegistrar['name'].length : 0) + '/50';
    }
  },
  watch: {
    user_role() {
      return JSON.parse(localStorage.getItem("userDetails")).role;
    },
    user_id() {
      return JSON.parse(localStorage.getItem("userDetails")).id;
    },
    formGeo() {
      return this.$store.getters.formGeo;
    },
    formAMs() {
      return this.$store.getters.formAMs;
    }
  },
  methods: {
    submit() {
      // NOTE: Validate the form before submission
      this.$validator.validate().then(async (valid) => {
        if(valid) {
          var payload = {
            legal_name: this.formDataRegistrar['legal_name'],
            name: this.formDataRegistrar['name'],
            am_id: this.formDataRegistrar['accountManager'].value,
            country_id: this.formDataRegistrar['country'].value,
            website: this.formDataRegistrar['website'],
            tucows_onboarding_registrar_id: this.formDataRegistrar['tucows_onboarding_registrar']['value']
          }
  
          this.$axiosSecure
          .post('/tucows/unique-registrars', payload)
          .then((response) => {
            if(response.data.type == 'Success') {
              this.resetForm();

              this.$vs.dialog({
                color: 'success',
                title: 'Success',
                text: 'Registrar added successfully!',
                acceptText: 'Close',
                accept: () => {},
              });

              // NOTE: Reset Form validation after submit
              this.$validator.pause()
              this.$nextTick(() => {
                this.$validator.errors.clear();
                this.$validator.fields.items.forEach(field => field.reset());
                this.$validator.fields.items.forEach(field => this.errors.remove(field));
                this.$validator.resume();
              })
            } else {
              let liStr = '';
              response.data.message.forEach((el, index) => {
                liStr += `${index+1}. ${el}<br>`
              })
              this.customPromptError = liStr;
              this.customPrompt["type"] = "error";
              this.customPrompt["classList"] = "danger-prompt";
              this.customPrompt["color"] = "danger";
              this.customPrompt["activePrompt"] = true;

              // TODO: Add a call to update new set of registrars
              this.$store.dispatch('setClientOptions');
            }
          })
          .catch((error) => {
            let liStr = '';
            error.response.data.message.forEach((el, index) => {
              liStr += `${index+1}. ${el}`
            })
            this.customPromptError = liStr;
            this.customPrompt["type"] = "error";
            this.customPrompt["classList"] = "danger-prompt";
            this.customPrompt["color"] = "danger";
            this.customPrompt["activePrompt"] = true;
          });
        } else {
          var errors = this.errors.collect();
        }
      })
    },
    resetForm() {
      this.formDataRegistrar = {
        legal_name: null,
        name: null,
        accountManager: {
          label: 'NA',
          value: null
        },
        country: {
          label: 'NA',
          value: null
        },
        website: null,
        tucows_onboarding_registrar: null,
        iana_id: null
      }

      this.customPrompt = {
        activePrompt: false,
        title: null,
        buttonText: null,
        type: null,
        color: null,
        classList: null,
        accept: null
      }
    }
  }
}
</script>